import React from 'react';
import { FormattedMessage } from 'react-intl';

export const CUSTOM_CSS_MESSAGE = <FormattedMessage
    id="oe.website.customCss"
    defaultMessage="Custom Css"
    description="Label text"
/>;

export const CODE_EDITOR_HEIGHT = 'calc(100% - 16px)';

export const CUSTOM_CSS_SAVING_TEXTS = {
    id: 'oe.website.customCssIsBeingSaved',
    description: 'Placeholder about saving custom CSS',
    defaultMessage: 'Custom CSS is being saved, please wait...',
};
